import { render, staticRenderFns } from "./seo.vue?vue&type=template&id=cf291d7e&scoped=true&"
import script from "./seo.vue?vue&type=script&lang=js&"
export * from "./seo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf291d7e",
  null
  
)

export default component.exports